import React from "react";
import Stack from "../layout/Stack";
import KeyValueRow from "./KeyValueRow";

export default function KeyValueList({
  items = [],
  gap = "3",
  className = "",
}) {
  return (
    <Stack gap={gap} className={className}>
      {items.map(function (item, index) {
        return (
          <KeyValueRow
            key={index}
            label={item.label}
            value={item.value}
            align={item.align || "right"}
          />
        );
      })}
    </Stack>
  );
}